var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toObject } from '@src/utils/qs';
import { getSession } from '../../session';
import { parseSession } from '../../session/helpers';
import { pruneNilValues } from '../utils';
import { sendPixelTracking } from './sendPixelTracking';
import { sendTracking } from './sendTracking';
export const sendTrackingWithSession = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const session = yield getSession();
    return sendTracking(Object.assign(Object.assign({}, args), { data: Object.assign(Object.assign({}, pruneNilValues(parseSession(session))), (args.data || {})) }));
});
export const sendPixelTrackingWithSession = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const session = yield getSession();
    if (!session) {
        return;
    }
    return sendPixelTracking(Object.assign(Object.assign({}, args), { data: Object.assign(Object.assign({}, parseSession(session)), (args.data || {})) }));
});
export const utmParams = () => {
    const searchParams = toObject(window.location.search);
    return {
        utm_source: searchParams.utm_source,
        utm_medium: searchParams.utm_medium,
        utm_campaign: searchParams.utm_campaign,
        utm_term: searchParams.utm_term,
        utm_content: searchParams.utm_content,
    };
};
